import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "bt-icon bt-icon--sm text-dark" }
const _hoisted_3 = { class: "ml-3" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "bt-icon bt-icon--sm text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_DeviceSlotsListOverview = _resolveComponent("DeviceSlotsListOverview")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    class: ["card--slim card--device", { 'is-selected': _ctx.device.isSelected }]
  }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_InlineSvgScoped, {
            src: require(`@/assets/images/icons/icon-${_ctx.icon}.svg`),
            "aria-label": "icon-blueprint"
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.Model")) + ": " + _toDisplayString(_ctx.device.model) + ", ID: " + _toDisplayString(_ctx.device.id), 1),
          _createVNode(_component_DeviceSlotsListOverview, {
            device: _ctx.device,
            slotList: _ctx.device.slots
          }, null, 8, ["device", "slotList"])
        ]),
        _createVNode("div", _hoisted_5, [
          (_ctx.device.isAnomaly)
            ? (_openBlock(), _createBlock("span", _hoisted_6, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                require('@/assets/images/icons/icon-alert-hight-full.svg')
                            ,
                  "aria-label": "icon-alert-hight-full"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            icon: "pi pi-chevron-right",
            class: "p-button-text text-dark ml-3 p-0"
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}